/**
 * @fileoverview
 * User type guard – allows routes only for specific `userType` values (from auth / localStorage user).
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services';
import { UserType } from '../models';

export const userTypeGuard = (allowedUserTypes: UserType[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const user = authService.user();

    if (!user) {
      return router.createUrlTree(['/auth/login']);
    }

    if (allowedUserTypes.includes(user.userType)) {
      return true;
    }

    return router.createUrlTree(['/unauthorized']);
  };
};
